import { memo } from 'react';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import classNames from 'classnames';
import BeginnersGuideAvatarImage
    from '../BeginnersGuide/components/BeginnersGuideAvatarImage/BeginnersGuideAvatarImage';
import { Button } from 'react-bootstrap';
import {
    BeginnersGuideInviteAvatarDesktopStyled,
    BeginnersGuideInviteButtonsDesktopStyled,
    BeginnersGuideInviteDesktopOverlayStyled,
    BeginnersGuideInviteDialogDesktopStyled,
    BeginnersGuideInviteMessageDesktopStyled,
} from '../BeginnersGuide/styled/BeginnersGuideInviteDesktop';
import { IBeginnersGuideInviteProps } from './beginnersGuideInvite.t';

function BeginnersGuideInviteDesktop(props: IBeginnersGuideInviteProps) {
    const { isVisible, onButtonCloseClickHandler, onButtonOpenClickHandler } = props;
    const { getLangPath } = useLangContext();

    return <BeginnersGuideInviteDesktopOverlayStyled className={classNames({ hidden: !isVisible })}>
        <BeginnersGuideInviteDialogDesktopStyled>
            <BeginnersGuideInviteMessageDesktopStyled dangerouslySetInnerHTML={{
                __html: getLangPath('tutorials.beginners_guide.invite.message'),
            }}/>

            <BeginnersGuideInviteButtonsDesktopStyled>
                <Button variant={'primary'} size={'sm'} onClick={onButtonOpenClickHandler}>
                    {getLangPath('tutorials.beginners_guide.invite.open_button')}
                </Button>
                <Button variant={'secondary'} size={'sm'} onClick={onButtonCloseClickHandler}
                        className={'backdrop-filter-blur20'}>
                    {getLangPath('tutorials.beginners_guide.invite.close_button')}
                </Button>
            </BeginnersGuideInviteButtonsDesktopStyled>
        </BeginnersGuideInviteDialogDesktopStyled>
        <BeginnersGuideInviteAvatarDesktopStyled>
            <BeginnersGuideAvatarImage imageName={'avatar-full-face-angle'}/>
        </BeginnersGuideInviteAvatarDesktopStyled>
    </BeginnersGuideInviteDesktopOverlayStyled>;
}

export default memo(BeginnersGuideInviteDesktop);
